module.exports = __webpack_public_path__ + "static/media/gargoyle.c97ff039.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bot_icons/gargoyle.png
// module id = 95
// module chunks = 0